const modalPhotoEditorUserMyAccount = {
  title: 'Editar Minha Foto'
};

export default modalPhotoEditorUserMyAccount;
